import React, { useState } from "react";
import { IconDownload,  } from "@tabler/icons-react";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import DropdownFilter from "../../components/common/DropdownFilter";
import NormalSearch from "../../components/common/NormalSearch";
import ListView from "../../components/common/ListView";
import CommonModal from "../../components/common/CommonModal";

const driverData = [
  {
    id: 1,
    img: "/img/odometer.png",
    driverId: "#4612150",
    startKm: "1200 km",
    endKm: "1500 km",
    totalKm: "300 km",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 2,
    img: "/img/odometer.png",
    driverId: "#4612150",
    startKm: "1200 km",
    endKm: "1500 km",
    totalKm: "300 km",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 3,
    img: "/img/odometer.png",
    driverId: "#4612150",
    startKm: "1200 km",
    endKm: "1500 km",
    totalKm: "300 km",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 4,
    img: "/img/odometer.png",
    driverId: "#4612150",
    startKm: "1200 km",
    endKm: "1500 km",
    totalKm: "300 km",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 5,
    img: "/img/odometer.png",
    driverId: "#4612150",
    startKm: "1200 km",
    endKm: "1500 km",
    totalKm: "300 km",
    date: "4 Aug 2025",
    active: true,
  },
];

const Odometer: React.FC = () => {
  const [openOdoMeter, setOpenOdoMeter] = useState<boolean>(false);
  const openOdoMeterToggleModal = () => {
    setOpenOdoMeter(!openOdoMeter);
  };
  return (
    <>
      <div className="p-4 space-y-4">
        <h1 className="text-3xl text-[#212121] ">Driver Management</h1>
        <div className="bg-[#F7F6F2] rounded-3xl">
          <div className="flex justify-between items-center w-full  p-4">
            <div className="flex justify-between items-center  rounded-tl-3xl rounded-tr-3xl">
              <h1 className="text-3xl text-[#212121]">Odometer History</h1>
            </div>
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <div className="flex items-center gap-2">
                <ColumnsFilter columnsData={[]} />
                <DropdownFilter filterheadings={[]} />
                <NormalSearch />
              </div>
              <button className="p-2 text-sm rounded-full border border-[#D8D8D8] bg-white">
                <IconDownload stroke={1.5}  size={20}/>
              </button>
            </div>
          </div>
          <div>
            {" "}
            <ListView
              data={driverData}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={[
                { label: "#", render: (_, i) => i + 1 },
                {
                  label: "Driver Id",
                  render: (c) => c.driverId,
                },
                { label: "Start km", render: (c) => c.startKm },
                { label: "End km", render: (c) => c.endKm },
                { label: "Total  km ", render: (c) => c.totalKm },
                { label: "Date", render: (c) => c.date },
                {
                  label: "Attachment",
                  render: (c) => (
                    <div
                      onClick={openOdoMeterToggleModal}
                      className="flex items-center gap-2 truncate max-w-xs  "
                    >
                      <img src={c.img} alt={c.driverId} />
                    </div>
                  ),
                },
                // {
                //   label: "Actions",
                //   render: () => (
                //     <button className="p-2 border rounded-full bg-[#F7F6F2]">
                //       <IconEye />
                //     </button>
                //   ),
                // },
              ]}
            />
          </div>
        </div>
      </div>

      <CommonModal
        title={"Meter Preview"}
        open={openOdoMeter}
        closeButtonText={"Cancel"}
        onClose={openOdoMeterToggleModal}
        actionButtonText="Download"
        actionButtonOnClick={openOdoMeterToggleModal}
        actionButtonIcon={<IconDownload stroke={1.5}  size={20}/>}
      >
        <div className="p-6">
          <img
            src="/img/odometer-preview.png"
            alt=""
            className="w-fit rounded"
          />
        </div>
      </CommonModal>
    </>
  );
};

export default Odometer;
